import { render, staticRenderFns } from "./LowerThird.vue?vue&type=template&id=6fe75bf3"
import script from "./LowerThird.vue?vue&type=script&lang=js"
export * from "./LowerThird.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports